import React from "react";
import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import BoltIcon from "@mui/icons-material/Bolt";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router-dom";
import "./crearProyectoPublico.css";

export default function AccesoProyectosPublicoPage() {
  const navigate = useNavigate();
  const [legalOpen, setLegalOpen] = React.useState(false);

  return (
    <Box className="tramites-public-page">
      <Box className="tramites-public-topbar">
        <Container maxWidth="lg" className="tramites-public-topbar-inner">
          <Box className="tramites-public-gov-wrap">
            <img src="/images/logo2.webp" alt="GOV.CO" className="tramites-public-gov-logo" />
          </Box>
          <Typography className="tramites-public-lang">ES</Typography>
        </Container>
      </Box>

      <Box className="tramites-public-logobar">
        <Container maxWidth="lg" className="tramites-public-logobar-inner">
          <Box className="tramites-public-logo-block">
            <img src="/images/logo-emcali.webp" alt="EMCALI" className="tramites-public-logo" />
          </Box>
          <a href="/" className="tramites-public-back-btn">
            Volver
          </a>
        </Container>
      </Box>

      <Box className="tramites-public-main">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Box className="tramites-access-hero">
            <Box className="tramites-access-copy">
              <Typography className="tramites-public-title">Proyectos de Conexion Clase 2</Typography>
              <Typography className="tramites-access-text">
                La radicacion en linea aplica para proyectos de <strong>media tension</strong>. Para
                solicitudes distintas a media tension, el tramite debe realizarse en un{' '}
                <strong>centro de atencion al cliente</strong> EMCALI (CAP).
              </Typography>
              <Typography className="tramites-access-text">
                Desde aqui puede consultar requisitos o iniciar la solicitud virtual cuando corresponda.
              </Typography>
              <Typography className="tramites-access-text">
                Elija una opcion:
              </Typography>

              <Box className="tramites-access-actions">
                <button type="button" className="tramites-access-btn" onClick={() => setLegalOpen(true)}>
                  <BoltIcon fontSize="small" />
                  Solicitar servicio de energia
                </button>
                <a href="/proyectos/crear/correccion" className="tramites-access-btn">
                  <SearchIcon fontSize="small" />
                  Corregir datos o cargar documentos
                </a>
                <a href="/proyectos/crear/estado" className="tramites-access-btn">
                  <SearchIcon fontSize="small" />
                  Ver estado de proyecto
                </a>
              </Box>
            </Box>
          </Box>

          <Box className="tramites-access-guide">
            <Box>
              <Typography className="tramites-access-guide-text">
                Si presenta un proyecto de conexion clase 2 en el sistema de distribucion local EMCALI-SDL,
                consulte la guia de documentos y procedimientos antes de radicar.
              </Typography>
              <button type="button" className="tramites-access-btn" style={{ marginTop: 16 }}>
                <DownloadIcon fontSize="small" />
                Descargar guia
              </button>
            </Box>
          </Box>
        </Container>
      </Box>

      <Dialog
        open={legalOpen}
        onClose={() => setLegalOpen(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ fontWeight: 800 }}>Proteccion Datos Personales - Aviso de Privacidad</DialogTitle>
        <DialogContent dividers sx={{ maxHeight: "65vh" }}>
          <Typography variant="body2" sx={{ mb: 2 }}>
            El presente Aviso de Privacidad establece los terminos y condiciones en virtud de los cuales
            EMCALI EICE ESP, identificado con NIT 890.399.003-4 y con domicilio principal en el Centro
            Administrativo Municipal - CAM Torre EMCALI piso 3 de Cali, realizara el tratamiento de sus
            datos personales.
          </Typography>

          <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1 }}>
            1. Tratamiento y finalidad
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            La recoleccion, almacenamiento, uso y circulacion de la informacion personal recolectada sera
            utilizada para:
          </Typography>
          <ul style={{ marginTop: 0, paddingLeft: 18 }}>
            <li>Efectuar las gestiones pertinentes para el desarrollo del objeto social de EMCALI EICE ESP.</li>
            <li>Realizar invitaciones a eventos y ofrecer nuevos productos y servicios.</li>
            <li>Gestionar tramites (solicitudes, quejas, reclamos, ventas e instalacion de servicio).</li>
            <li>Efectuar encuestas de satisfaccion respecto de bienes y servicios ofrecidos.</li>
            <li>Suministrar informacion de contacto a fuerza comercial, telemercadeo e investigacion.</li>
            <li>Contactar al titular por medios telefonicos para encuestas o confirmacion de datos.</li>
            <li>Contactar al titular por medios electronicos, SMS o chat para campañas de servicio.</li>
            <li>Contactar por correo electronico para extractos, estados de cuenta o facturas.</li>
            <li>Dar cumplimiento a obligaciones legales y contractuales aplicables.</li>
            <li>Transferir o transmitir datos personales cuando sea necesario para objeto contractual.</li>
            <li>Prestar los servicios ofrecidos por EMCALI EICE ESP y aceptados por el titular.</li>
            <li>Tramitar solicitudes o peticiones en CAP, CALI, linea 177 y pagina web oficial.</li>
          </ul>

          <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1, mt: 2 }}>
            2. Derechos del titular
          </Typography>
          <ul style={{ marginTop: 0, paddingLeft: 18 }}>
            <li>Acceder en forma gratuita a los datos proporcionados y objeto de tratamiento.</li>
            <li>Conocer, actualizar y rectificar informacion parcial, inexacta o incompleta.</li>
            <li>Solicitar prueba de la autorizacion otorgada.</li>
            <li>Presentar quejas ante la Superintendencia de Industria y Comercio (SIC).</li>
            <li>Revocar autorizacion y/o solicitar supresion cuando sea procedente.</li>
            <li>Abstenerse de responder preguntas sobre datos sensibles.</li>
          </ul>

          <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1, mt: 2 }}>
            Mecanismos para conocer la politica de tratamiento
          </Typography>
          <Typography variant="body2">
            El titular puede acceder a la Politica de Tratamiento de Informacion publicada en
            www.emcali.com.co.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button variant="outlined" onClick={() => setLegalOpen(false)}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setLegalOpen(false);
              navigate("/proyectos/crear/solicitud");
            }}
          >
            Acepto
          </Button>
        </DialogActions>
      </Dialog>

      <Box className="tramites-public-footer">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Box className="tramites-public-footer-grid">
            <Box>
              <img
                src="/images/LOGO-EMCALI-vertical-1-tinta-blanca.webp"
                alt="EMCALI"
                className="tramites-public-footer-brand"
              />
            </Box>
            <Box>
              <Typography className="tramites-public-footer-title">Sede Electrónica</Typography>
              <Typography className="tramites-public-footer-text">
                Av 2N entre Calles 10 y 11, CAM Torre EMCALI.
              </Typography>
              <Typography className="tramites-public-footer-text">
                Horario: Lunes a viernes 8:00AM a 5:00PM.
              </Typography>
              <Typography className="tramites-public-footer-text">
                Linea de atencion: 177 - 018000 4 12017
              </Typography>
            </Box>
            <Box>
              <Typography className="tramites-public-footer-title">Información</Typography>
              <Typography className="tramites-public-footer-text">Terminos y condiciones</Typography>
              <Typography className="tramites-public-footer-text">Proteccion de datos personales</Typography>
              <Typography className="tramites-public-footer-text">Mapa del sitio</Typography>
            </Box>
            <Box className="tramites-public-footer-seals">
              <img src="/images/image 7.png" alt="Colombia" className="tramites-public-seal" />
              <img src="/images/image 8.png" alt="Icontec" className="tramites-public-seal" />
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
